export default __webpack_public_path__ + "static/media/share-file.bd3a4ddd.svg";